import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { AzureChip, ForestChip, SaffronChip, SlateChip } from "./HXDesktopChips.styles";
import { HXDialogHeader } from "./HXDialog";
import { HXMenuButton } from "./HXMenuButton";
export const AdminWebhooksViewParent = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const AddWebhookDialogHeader = styled(HXDialogHeader) `
    padding-bottom: 20px;
`;
export const IntroAndActionsRow = styled.div `
    display: flex;
    align-items: flex-start;
    gap: 64px;
    margin-top: 16px;

    & > *:last-child {
        flex-shrink: 0;
    }
`;
export const IntroText = styled.div `
    flex: 1;
    min-width: 0;
    color: ${colors.black_light};
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const DestructiveText = styled.div `
    li:not(.Mui-disabled) & {
        color: ${colors.tulip_main};
    }
`;
export const MonoText = styled.span `
    font-family: monospace;
    font-size: ${fontSizes.LITTLE};
    color: ${colors.black_lighter};
`;
export const ProjectScopeCell = styled.span `
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    min-width: 0;

    /* Let the project-name chip shrink (and ellipsize its label) beside the "+N more" chip. */
    & > *:first-child {
        min-width: 0;
    }
`;
export const ChipActive = styled(ForestChip) `
    font-weight: ${fontWeights.NORMAL};
    text-transform: none;
`;
export const ChipAutoPaused = styled(SaffronChip) `
    font-weight: ${fontWeights.NORMAL};
    text-transform: none;
`;
export const ChipNeutral = styled(SlateChip) `
    font-weight: ${fontWeights.NORMAL};
    text-transform: none;
`;
export const ChipOrgWide = styled(AzureChip) `
    font-weight: ${fontWeights.NORMAL};
    text-transform: none;
`;
export const ChipMore = styled(ChipNeutral) `
    flex-shrink: 0;
`;
const outcomeColor = (outcome) => {
    switch (outcome) {
        case "FAIL":
            return colors.tulip_main;
        case "WARN":
            return colors.sunset_main;
        case "OK":
        default:
            return colors.forest_main;
    }
};
export const HealthBar = styled.span `
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;
export const WebhookEmptyState = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 480px;
    margin: 0 auto;
    padding: 80px 24px 90px;
    text-align: center;
`;
export const EmptyMark = styled.div `
    position: relative;
    display: grid;
    place-items: center;
    width: 56px;
    height: 56px;
    margin-bottom: 20px;
    border: 1.5px solid ${colors.black_30};
    border-radius: 6px;
    color: ${colors.black_lighter};

    &::before {
        content: "";
        position: absolute;
        inset: 12px;
        border: 1.5px dashed ${colors.black_30};
        border-radius: 3px;
    }

    &::after {
        content: "\\21AF";
        position: relative;
        font-size: 20px;
    }
`;
export const EmptyTitle = styled.div `
    margin-bottom: 8px;
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.MEDIUM};
    color: ${colors.black_main};
`;
export const EmptyText = styled.div `
    margin-bottom: 22px;
    font-size: ${fontSizes.LITTLE};
    line-height: 1.55;
    color: ${colors.black_light};
`;
export const EmptyEventCode = styled.code `
    padding: 1px 6px;
    border-radius: 2px;
    background-color: ${colors.black_8};
    font-family: monospace;
    font-size: ${fontSizes.TINY};
`;
export const EmptyActions = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
`;
export const HealthTick = styled.span `
    width: 5px;
    height: 14px;
    border-radius: 1px;
    background-color: ${(props) => outcomeColor(props.outcome)};
`;
